import React from 'react';

export type Props = {
  className?: string;
  color?: string;
  height?: number;
  onClick?(): void;
  width?: number;
};

export const SearchLoupe = React.memo((props: Props) => {
  return (
    <svg
      width={props.width || 16}
      height={props.height || 16}
      className={props.className}
      onClick={props.onClick}
      viewBox='0 0 16 16'
    >
      <g fill='none'>
        <circle cx='7.58578' cy='7.58582' r='5' transform='rotate(-45 7.58578 7.58582)'
          stroke={props.color || 'white'} strokeWidth='2' strokeLinecap='round' />

        <path d='M11.8284 11.8284L14.2426 14.2426' stroke={props.color || 'white'} strokeWidth='2'
          strokeLinecap='round' />
      </g>
    </svg>
  );
});

SearchLoupe.displayName = 'SearchLoupe';
